import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'cms-overlay',
    templateUrl: './cms-overlay.component.html',
    standalone: false,
})
export class CmsOverlayComponent {
    @Input() zIndex = 1050;
    @Input() animated = true;

    @Output() backdropClick = new EventEmitter<MouseEvent>();

    onClick(event: MouseEvent): void {
        this.backdropClick.emit(event);
    }
}
